import axios from '@/utils/axios';

// 生成 套餐每期订单
export function SubmitPackagePeriodOrder(params) {
    return axios({
        url: '/package-period-order/submit',
        method: 'post',
        params,
    });
}

// 获取套餐每期订单详情
export function GetPackagePeriodOrder(params) {
    return axios({
        url: '/package-period-order',
        method: 'get',
        params,
    });
}

// 取消套餐每期订单
export function CancelPackagePeriodOrder(params) {
    return axios({
        url: '/package-period-order/cancel',
        method: 'post',
        params,
    });
}

// 获取 套餐每期订单 与 普通订单列表
export function ListOrderPackageAndNormal(params) {
    return axios({
        url: '/package-period-order/list',
        method: 'get',
        params,
    });
}

// 获取 套餐每期订单 与 普通订单 总数
export function GetOrderPackageAndNormalTotal(params) {
    return axios({
        url: '/package-period-order/total',
        method: 'get',
        params,
    });
}

// 套餐每期订单确认收货
export function ConfirmPackagePeriodOrder(packagePeriodOrderId) {
    return axios({
        url: '/package-period-order/confirm',
        method: 'post',
        params: {packagePeriodOrderId},
    });
}